import { Folder } from 'lucide-react'
import clsx from 'clsx'
import { Tile, TileContent, TileDescription, TileTitle } from './Tile'

const FOLDER_TILE_MIN_H = 'min-h-48'

interface FolderTileProps {
  name: string
  countLabel?: string
  onClick?: () => void
  onDropBaustein?: (bid: number) => void
}

export function FolderTile({ name, countLabel, onClick, onDropBaustein }: FolderTileProps) {
  return (
    <Tile
      variant="interactive"
      onClick={onClick}
      className={clsx('h-full', FOLDER_TILE_MIN_H)}
      onDragOver={(e) => {
        if (!onDropBaustein) return
        e.preventDefault()
      }}
      onDrop={(e) => {
        if (!onDropBaustein) return
        e.preventDefault()
        const bid = Number(e.dataTransfer.getData('text/plain'))
        if (Number.isInteger(bid) && bid > 0) {
          onDropBaustein(bid)
        }
      }}
    >
      <TileContent
        className={clsx('flex h-full flex-col items-start justify-between gap-2 p-4', FOLDER_TILE_MIN_H)}
      >
        <Folder className="h-8 w-8 shrink-0 text-amber-500 dark:text-amber-400" aria-hidden />
        <div className="w-full min-w-0">
          <TileTitle className="line-clamp-2 text-sm">{name}</TileTitle>
          {countLabel ? <TileDescription className="truncate">{countLabel}</TileDescription> : null}
        </div>
      </TileContent>
    </Tile>
  )
}
